module.exports = __webpack_public_path__ + "static/media/toolbar-user-icon.c398950b.svg";